const cartObj = {
  initiated: false,
  contactItems: {},
  order: {
    status: 'preprocessing',
    id: null,
    createdAt: ''
  },
  shipping: 0,
  tax: 0,
  total: 0,
  cartDate: '',
  arbitraryCartId: '',
  companyContactId: '',
  companyId: '',
  companyLocationId: '',
  recipientsQuantity: 0,
  productQuantity: 0,
  checkoutUrl: '',
  cartId: ''
};

// @todo Markets must be driven by configuration, so that is easier to add a new one
const marketCarts = {
  nz: cartObj,
  au: cartObj,
  za: cartObj,
  sg: cartObj,
  jp: cartObj,
  cn: cartObj,
  de: cartObj,
  gb: cartObj,
  ie: cartObj,
  ch: cartObj,
  it: cartObj,
  nl: cartObj,
  es: cartObj,
  fr: cartObj,
  at: cartObj, // Austria, not yet launched
  pt: cartObj // Portugal, not yet launched
};

export default marketCarts;
